import { render, staticRenderFns } from "./MoneyField.vue?vue&type=template&id=f87a9404&scoped=true&"
import script from "./MoneyField.vue?vue&type=script&lang=js&"
export * from "./MoneyField.vue?vue&type=script&lang=js&"
import style0 from "./MoneyField.vue?vue&type=style&index=0&id=f87a9404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87a9404",
  null
  
)

export default component.exports